import { isEmpty as isEmptyObject, isNotNil } from '../../util/object';

/**
 * A wrapper for a Tag wire object.
 */
export default class Tag {
  _adAccountId;
  _id;
  _name;
  _organizationId;
  _parentTagId;
  _publisherId;
  _type;

  constructor(tag) {
    if (!isEmptyObject(tag)) {
      const {
        ad_account_id: adAccountId,
        id,
        name,
        organization_id: organizationId,
        parent_tag_id: parentTagId,
        publisher_id: publisherId,
        type,
      } = tag;

      if (isNotNil(adAccountId)) {
        this._adAccountId = adAccountId;
      }

      if (isNotNil(id)) {
        this._id = id;
      }

      if (isNotNil(name)) {
        this._name = name;
      }

      if (isNotNil(organizationId)) {
        this._organizationId = organizationId;
      }

      if (isNotNil(parentTagId)) {
        this._parentTagId = parentTagId;
      }

      if (isNotNil(publisherId)) {
        this._publisherId = publisherId;
      }

      if (isNotNil(type)) {
        this._type = type;
      }
    }
  }

  get id() {
    return this._id;
  }

  get name() {
    return this._name;
  }

  get type() {
    return this._type;
  }

  get parentTagId() {
    return this._parentTagId;
  }

  get organizationId() {
    return this._organizationId;
  }

  get adAccountId() {
    return this._adAccountId;
  }

  get publisherId() {
    return this._publisherId;
  }

  /**
   * Checks if object is an instance of Tag
   *
   * @param inputObject
   * @returns {boolean}
   */
  static isTag(inputObject) {
    return inputObject instanceof Tag;
  }
}
